import { format } from 'date-fns'

export default {
    dailyReportsShiftSummaries: [],
    dailyReportsShiftSummariesLoading: false,
    user: null,
    dailyReportsShiftSummariesFilters: setInitialDailyReportsShiftSummariesFilters(),
    setInitialDailyReportsShiftSummariesFilters: setInitialDailyReportsShiftSummariesFilters
}

function setInitialDailyReportsShiftSummariesFilters() {
    return {
        startDateTime__lte: format(new Date(), 'YYYY-MM-DD'),
        startDateTime__gte: format(new Date(), 'YYYY-MM-DD'),
        user_id: null,
        group_id: null,
        report_object_number: null
    }
}
